export const enum OrderStatus {
    Draft = 0,
    Open = 1,
    Send = 2,
    Completed = 3,
}

export const enum OrderType {
    MaterialsOrder = 0,
    SubcontractorSettlement = 1,
    Other = 10,
}
